export default {"src":"/bnb/_next/static/media/chevron_right_dark.7db4411a.svg","height":24,"width":24};